import { Box, Typography } from '@mui/material';
import { Link } from 'lucide-react';
import PropertiesTooltip from '~/components/Properties/PropertiesTooltip';
import RegistrationProperties from '~/components/Properties/RegistrationProperties';
import SelectableListItem from '~/components/SelectableListItem/SelectableListItem';
import ReviewStatus from '~/components/Structures/ReviewStatus';
import { DICOMApprovalStatus } from '~/domain/dicom/dicomConstants';
import { RigidRegistration } from '~/domain/patient/rigidRegistration';

interface RegistrationItemProps {
    label: string;
    approvalStatus?: DICOMApprovalStatus;
    isSelected?: boolean;
    onClick?: () => void;
    registration?: RigidRegistration;
    onDelete?: () => void;
}

export default function RegistrationItem({
    label,
    approvalStatus,
    isSelected,
    onClick,
    registration,
    onDelete,
}: RegistrationItemProps) {
    const content = (
        <Box
            display="flex"
            alignItems="center"
            gap={1}
            width="100%"
            overflow="hidden"
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 18,
                    height: 18,
                    borderRadius: 1,
                    border: '1px solid',
                    borderColor: isSelected ? 'primary.main' : 'divider',
                    bgcolor: isSelected
                        ? 'rgba(144, 202, 249, 0.12)'
                        : 'background.paper',
                    color: isSelected ? 'primary.main' : 'text.secondary',
                    flexShrink: 0,
                    transition: 'all 0.15s ease-in-out',
                }}
            >
                <Link size={10} />
            </Box>

            <Typography
                fontSize={12}
                color={isSelected ? 'text.primary' : 'text.secondary'}
                noWrap
                flex={1}
                minWidth={0}
                sx={{ transition: 'color 0.15s ease-in-out' }}
            >
                {label}
            </Typography>
            {approvalStatus !== undefined && (
                <Box flexShrink={0}>
                    <ReviewStatus
                        status={approvalStatus}
                        fontSize={10}
                        color={isSelected ? 'text.primary' : 'text.secondary'}
                    />
                </Box>
            )}
        </Box>
    );

    const wrappedContent = registration ? (
        <PropertiesTooltip
            title={
                <RegistrationProperties
                    registration={registration}
                    onDelete={onDelete}
                />
            }
        >
            {content}
        </PropertiesTooltip>
    ) : (
        content
    );

    return (
        <SelectableListItem isSelected={isSelected} onClick={onClick}>
            {wrappedContent}
        </SelectableListItem>
    );
}
